import { AccommodationType, HOTEL_TYPES } from '@libs/trip-planner-interfaces';

export function isTicketActivity(productType: AccommodationType): boolean {
  return productType === AccommodationType.Ticket;
}

export function isGolfActivity(productType: AccommodationType): boolean {
  return productType === AccommodationType.Golf;
}

export function isAccommodation(productType?: AccommodationType): boolean {
  if (!productType) {
    return false;
  }
  return HOTEL_TYPES.includes(productType);
}
